<section class="error-pages text-center">
  <button class="custom-btn btn-12" (click)="BacktoDashboard()"><span>Click</span><span>Back to Home</span></button>
</section>
